/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  var monthToFullName = function (month) {
    switch (month) {
      case 0:
        return 'January';
      case 1:
        return 'February';
      case 2:
        return 'March';
      case 3:
        return 'April';
      case 4:
        return 'May';
      case 5:
        return 'June';
      case 6:
        return 'July';
      case 7:
        return 'August';
      case 8:
        return 'September';
      case 9:
        return 'October';
      case 10:
        return 'November';
      case 11:
        return 'December';
    }
  };
  var dateRefresh = function () {
    $('.date-container .date-text').text(monthToFullName(date.getMonth()) + ' ' + date.getFullYear());
  };
  var date = new Date();
  var thisMonth = date.getMonth(), thisTime = date.getTime();

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        var $body = $('body');

        var $header = $("header:not(.sticky)");
        var $stickyHeader = $header.clone().addClass('sticky').hide();
        $header.after($stickyHeader);
        
        $(window).on("scroll", function() { 
          var fromTop = $(window).scrollTop();
          if ($header.find('nav').length && fromTop > $header.find('nav').offset().top) {
            if ($stickyHeader.is(':hidden')) {
              $stickyHeader.fadeIn();
            }
          } else {
            if ($stickyHeader.is(':visible')) {
              $stickyHeader.fadeOut();
            }
          }
        });

        $('body').on('click', '.menu-toggle', function() {
          $(this).closest('nav').toggleClass('toggled');
        });

        $('header ul#menu-primary-menu li.current-menu-item').addClass('open');
        $('body').on('click', 'header ul#menu-primary-menu a', function(e) {
          if ($(window).width() >= 1170)
            return;

          if (e.target.offsetWidth - e.offsetX < 60 && $(this).closest('li').hasClass('menu-item-has-children')) {
            $(this).closest('li').toggleClass('open');
            e.preventDefault();
          } else
            $(this).closest('nav').toggleClass('toggled');
        });
        
        $(window).load(function() {
          $('.parallax-box').each(function() {
            $this = $(this);
            if ($this.hasClass('full-height'))
              $this.css('height', $(window).height() + 'px');

            $this.find('.parallax-background').css('height', ($this.height() + ($(window).height() - $this.height())*0.2) + 'px').parallax("0", -0.2);
          });
        });

        $('.main-carousel').on('init', function() { $(this).parallax("0", -0.2); });

        $(window).on('load resize', function () {
          if ($(window).width() >= 768) {
            equalheight('.boxed-gold');
            equalheight('.equal-height');
          
          } else {
            $('.boxed-gold').css('height', 'auto');
          }
        });

        var userObj = localStorage.getItem('user');
        if (userObj !== null) {
          userObj = JSON.parse(userObj);

          $body.addClass('member-logged-in');

          $('.lrc-private-form').show();
          if (userObj.first_name) {
            $('input[name=firstname]').val(userObj.first_name);
          }
          if (userObj.last_name) {
            $('input[name=lastname]').val(userObj.last_name);
          }
          if (userObj.phone) {
            $('input[name=telephone]').val(userObj.phone);
          }
          if (userObj.email) {
            $('input[name=email]').val(userObj.email_wp.substring(0, userObj.email_wp.length - 6)); 
            $('input[name=emailaddress]').val(userObj.email);
          }
          if (userObj.member_number) {
            $('input[name=member-number]').val(userObj.member_number);
          }
        }

        $('.main-carousel').slick({
          autoplay: true,
          autoplaySpeed: 8000,
          speed: 1000,
          infinite: true,
          fade: true,
          arrows: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          pauseOnDotsHover: false,
          cssEase: 'linear',
          lazyLoad: 'progressive',
          dots: true
        });

        $('.open_search_button').click(function () {
          if ($body.hasClass('open_search')) {
            $('body').removeClass('open_search');
            $(this).show();
          } else {
            $('body').addClass('open_search');
            $(this).hide();
          }
        });

        $('.board-carousel').on('init', function (event, slick) {
          $(".board-carousel").animate({opacity: 1});
        });

        $('.board-carousel').slick({
          autoplay: true,
          autoplaySpeed: 7000,
        });
        $('#datetimepicker12').datetimepicker({
          format: 'DD/M/YYYY',
          inline: true,
        });
        $('#datetimepicker2').datetimepicker({
          format: 'DD/M/YYYY'
        });

        $('form').each(function(index, form) {
          var saved = localStorage.getItem($(form).attr('action'));
          if (saved) {
            $(form).find('input[type=checkbox]').prop('checked', false);
            var items = saved.split(',');
            items.forEach(function(value, index) {
              if (value != '')
                $(form).find('input[type=checkbox][value=' + value + ']').prop('checked', true);
            });
          }
        });

        $body.on('click', '.showFilter', function () {
          $(this).siblings().slideToggle();
          $(this).find('i').toggleClass('fa-plus-square').toggleClass('fa-minus-square');
        });
        $body.on('click', '#apply-filter-btn', function () {
          var cats = '';
          var action = $(this).closest('form').attr('action');
          $(this).closest('form').find('input:checked').each(function (index, cat) {
            cats += $(cat).val() + ',';
          });
          localStorage.setItem(action, cats);
          if (cats == '') {
            $(this).closest('form').find('input[type=checkbox]').each(function(index, cat) {
              $(cat).prop('checked', true);
            });
          }
          var url = action + '?cat=' + cats + '&date=' + Math.round(date.getTime() / 1000);
          loadAjax(url);

          if ($(window).width() < 768) {
            $('.showFilter').siblings().slideToggle();
            $('.showFilter').find('i').toggleClass('fa-plus-square').toggleClass('fa-minus-square');
          }
        });
        $(document).on('click', '.post-type-archive a.page-numbers', function (e) {
          e.preventDefault();
          var url = $(this).attr('href');
          loadAjax(url);
        });
        $(document).on('click', '.post-type-archive a.read-more', function (e) {
          e.preventDefault();
          var url = $(this).attr('href');
          loadAjax(url);
        });
        $body.on('click', '#reset-filter-btn', function () {
          $(this).parent('form').find('input').prop("checked", true);
          date = new Date();
          dateRefresh();
        });
        $body.on('click', '.news-filter label', function (e) {
          e.stopPropagation();
          if (e.target.nodeName === "LABEL" && e.offsetX > 21) {
            e.preventDefault();
            $(this).closest('.news-filter').find('input').prop("checked", false);
            $(this).find('input').prop("checked", true);
          }
        });
        $body.on('click', '#clear-filter-btn', function () {
          $(this).parent('form').find('input').prop("checked", false);
        });
        $('.news-filter input').change(function() {
          var $ul = $(this).closest('ul');
          var $input = $ul.siblings('label').find('input');
          var on = true;
          $ul.find('> li > label input').each(function(index, el) {
            if (!el.checked)
              on = false;
          });
          $input.prop('checked', on);

          $ul = $(this).closest('label').siblings('ul');
          on = this.checked;
          $ul.find('> li > label input').each(function(index, el) {
            $(el).prop('checked', on);
          });
        });
        if ($body.attr('class').indexOf('notice') > -1 ||
          $body.attr('class').indexOf('event') > -1 ||
          $body.attr('class').indexOf('promotion') > -1)
          $(window).on('popstate', function() {
            loadAjax(document.location);
          });

        var start = jQuery('.date-start input').first();
        var end = jQuery('.date-end input').first();
        start.on('change', function () {
          var start_date = $(this).datepicker('getDate');
          start_date.setDate(start_date.getDate() + 3);
          end.datepicker('option', 'minDate', start_date);
        });

        var openImgThumb = function($el) {
          if ($el.find('.desc, .btn').length == 0)
            return;

          $el.find('.caption').velocity({
            translateY: '0px',
          }, "easeInSine");
          $el.find('.img-thumb-bg').velocity({
            scale: '1.15'
          }, "easeInSine");
          $el.find('.btn-right').velocity({
            translateX: '0px'
          }, { easing: "easeIn", delay: 400});
          $el.find('.btn-left').velocity({
            translateX: '0px'
          }, { easing: "easeIn", delay: 400});
        };
        var closeImgThumb = function($el) {
          $el.find('.img-thumb-bg').velocity({
            scale: '1'
          }, "easeInSine");
          $el.find('.caption').velocity({
            translateY: ($el.height() - $el.find('.title').height() - 25) + 'px'
          }, "easeInSine");
          $el.find('.btn-right').velocity({
            translateX: '150px'
          }, "easeIn");
          $el.find('.btn-left').velocity({
            translateX: '-150px'
          }, "easeIn");
        };

        $('.img-thumb')
          .hover(
            function() {openImgThumb($(this));},
            function() {closeImgThumb($(this));}
          )
          .each(function(index, el) { closeImgThumb($(el)); })
          .click(
            function () {
              $(this).toggleClass('open');
              if ($(this).hasClass('open')) {
                openImgThumb($(this));
              } else {
                closeImgThumb($(this));
              }
            }
          );

        jQuery(document).on('keydown', function (e) {
          if (jQuery("#bwg_name").is(":focus") || jQuery("#bwg_email").is(":focus") || jQuery("#bwg_comment").is(":focus") || jQuery("#bwg_captcha_input").is(":focus")) {
            return;
          }
          if (e.keyCode === 39) { /* Right arrow.*/
            bwg_change_image(parseInt(jQuery('#bwg_current_image_key').val()), (parseInt(jQuery('#bwg_current_image_key').val()) + 1) % data.length, data);
          }
          else if (e.keyCode === 37) { /* Left arrow.*/
            bwg_change_image(parseInt(jQuery('#bwg_current_image_key').val()), (parseInt(jQuery('#bwg_current_image_key').val()) + data.length - 1) % data.length, data);
          }
          else if (e.keyCode === 27) { /* Esc.*/
            spider_destroypopup(1000);
          }
          else if (e.keyCode === 32) { /* Space.*/
            jQuery(".bwg_play_pause").trigger('click');
          }
          e.stopImmediatePropagation();
        });

        if (window.location.hash.match("^#lrcselect-")) {
          var parts = window.location.hash.split('-');
          $('select[name="' + parts[1] + '"] option[value="' + parts[2] + '"]').attr('selected', true);
        }

        $('body').on('click', '.vc_tta-accordion .vc_tta-panel-heading', function(e) {
          if ($(this).parent().hasClass('vc_active')) {
            var $that = $(this).parent();
            setTimeout(function() { $that.removeClass('vc_active'); }, 50);
          }
        });

        $body.on('click', 'a.3d-flip-book', function() {
          var issue = $(this).find('h3').text();
          gtag('event', 'magazine_view', {
            'magazine_issue': issue,
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        if ($(".board-holder .container .col-md-6.no-padding-mobile").length < 2) {
          $(".board-holder .container .col-md-6.no-padding-mobile").addClass("alignCenter");
        }
        if ($(".outlets-inner .container .col-md-6.no-padding-mobile").length < 2) {
          $(".outlets-inner .container .col-md-6.no-padding-mobile").addClass("alignCenter");
        }
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
        $('.events-carousel').on('init', function (event, slick) {
          $(".board").animate({opacity: 1});
        });
        $('.events-carousel').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                slidesToShow: 1
              }
            }
          ]
        });
        $('.experience-carousel').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                slidesToShow: 1
              }
            }
          ]
        });

        $('.gourmet-block').click(function () {
          location.href = "/dining/gourmet-10/";
        });
        $('.pizzeria-block').click(function () {
          location.href = "/dining/pizzeria/";
        });
        $('.pizzeria-block').hover(function () {
          /*$(this).find('img').animate(500, function() {
           $(this).attr("src","/wp-content/themes/lrc/assets/images/icon_pizza_hover.png");
           });*/
          $(this).find(".title-area").velocity({
            scale: '1.15'
          }, "easeInSine");
        }, function () {
          /*$(this).find('img').animate(500, function() {
           $(this).attr("src","/wp-content/themes/lrc/assets/images/icon_pizza.png");
           });*/
          $(this).find(".title-area").velocity({
            scale: '1'
          }, "easeInSine");
        });
        $('.gourmet-block').hover(function () {
          /*$(this).find('img').animate(500, function() {
           $(this).attr("src","/wp-content/themes/lrc/assets/images/icon_deli_hover.png");
           });*/
          $(this).find(".title-area").velocity({
            scale: '1.15'
          }, "easeInSine");
        }, function () {
          /*$(this).find('img').animate(500, function() {
           $(this).attr("src","/wp-content/themes/lrc/assets/images/icon_deli.png");
           });*/
          $(this).find(".title-area").velocity({
            scale: '1'
          }, "easeInSine");
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about': {
      init: function () {

        $('.year').on('init', function (event, slick) {
          $('[data-toggle="popover"]').popover({
            'viewport': '.timeline-holder'
          });
          $(".timeline-holder").animate({opacity: 1});
        });
        $('.year').slick({
          infinite: false,
          slidesToShow: 17,
          slidesToScroll: 8,
          autoplay: false,
          autoplaySpeed: 2000,
          speed: 1000,
          responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 14,
                slidesToScroll: 6,
              }
            },
            {
              breakpoint: 950,
              settings: {
                slidesToShow: 12,
                slidesToScroll: 4,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 10,
                slidesToScroll: 4,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              }
            }
          ]
        });

      }
    },
    'history': {
      init: function () {
        $('[data-toggle="popover"]').popover({
          'viewport': '.timeline-holder'
        });
      }
    },
    'post_type_archive_event': {
      init: function () {

        $('.date-prev').click(function () {
          if (date.getMonth() - 1 <= thisMonth)
            date.setTime(thisTime);
          else {
            date.setMonth(date.getMonth() - 1);
            date.setDate(1);
            date.setHours(0, 0, 0, 0);
          }
          dateRefresh();
        });
        $('.date-next').click(function () {
          date.setMonth(date.getMonth() + 1);
          date.setDate(1);
          date.setHours(0, 0, 0, 0);
          dateRefresh();
        });
        dateRefresh();
      }
    },
    // COVID forms autocomplete
    // 'page_template_template_bare': {
    //   init: function() {
    //     $( '.wpforms-field-text input' ).each(function(index, input) {
    //       var saved = localStorage.getItem($(input).attr('id'));
    //       if (saved) $(input).val(saved);
    //     });
    //     $( '.wpforms-field-text input' ).focusout( function(){
    //       localStorage.setItem($(this).attr('id'), $(this).val());
    //     });
    //   }
    // },
    'page_id_45': {
      init: function() {
        var clubs = {"Australia": [
          "Tattersalls Club - Hyde Park, Sydney",
          "Royal Automobile Club of Australia",
          "Peninsula Kingswood Country Golf Club",
          "Kooyong Lawn Tennis Club",
          "Royal South Yarra Lawn Tennis Club"
          ],
          "Belgium": [
          "Aspria Brussels Royal La Rasante",
          "Aspria Brussels Arts-Loi",
          "Aspria Brussels Avenue Louise"
          ],
          "Canada": [
          "Hollyburn Country Club",
          "Vancouver Lawn Tennis & Badminton Club",
          "The Union Club of British Columbia",
          "The Glencoe Club",
          "Toronto Cricket Skating & Curling Club",
          "The National Club"
          ],
          "China": [
          "Capital Club",
          "Shanghai Racquet Club"
          ],
          "France": ["Lagardere Paris Racing"],
          "Germany": [
          "Aspria Berlin Ku'damm",
          "Aspria Hamburg Alstertal",
          "Aspria Hamburg Uhlenhorst",
          "Aspria Hannover Maschsee",
          ],
          "India": ["Golden Swan Country Club"],
          "Italy": [
          "Aspria Harbour Club Milan",
          "Reale Circolo Canottieri Tevere Remo",
          "Tennis Club Parioli",
          ],
          "Japan": [
          "The Kobe Club",
          "Tokyo American Club",
          ],
          "Korea": ["Seoul Club"],
          "Malaysia": ["Penang Swimming Club"],
          "Philippines": ["Manila Polo Club"],
          "Singapore": [
          "Raffles Marina Ltd, Singapore",
          "The Tanglin Club",
          "The British Club",
          "Tower Club Singapore",
          ],
          "Sri Lanka": ["Colombo Swimming Club"],
          "Taiwan": ["American Club Taipei"],
          "Thailand": [
          "The British Club Bangkok",
          "Pacific City Club",
          ],
          "United Kingdom": [
          "The Hurlingham Club",
          "Oxford and Cambridge Club",
          "The University Women's Club",
          "The Sloane Club",
          "City University Club"
          ],
          "USA": [
          "Longwood Cricket Club",
          "Los Angeles Athletic Club",
          "California Yacht Club (in association with Los Angeles Athletic Club)",
          "The Cosmopolitan Club",
          "Union League Club of Chicago",
          "Woman's Athletic Club of Chicago",
        ]};
        
        $('select[name=country]').empty();
        Object.keys(clubs).forEach(function(country) {
          $('select[name=country]').append('<option value="' + country + '">' + country + '</option>');
        });
        $('select[name=country]').change(function() {
          var selected = $(this).val();
          $('select[name^=club]').find('option').remove();
          clubs[selected].forEach(function(club) {
            $('select[name^=club]').append('<option value="' + club + '">' + club + '</option>');
          });
        });
        $('select[name=country]').change();

        $(window).load(function(){
          var $date1 = $('[name=date-start]'),
              $date2 = $('[name=date-end]');
          $date1.datepicker('option', 'onSelect', function(value){
            var date = new Date(value);
            date.setDate(date.getDate() + 61);
            $date2.datepicker('option', 'minDate', value);
            $date2.datepicker('option', 'maxDate', date);
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common init JS
      UTIL.fire('common');

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  equalheight = function (container) {
    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
    $(container).each(function () {
      $el = $(this);
      $($el).height('auto');
      topPostion = $el.offset().top;

      if (Math.abs(currentRowStart - topPostion) > 2) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
    });

    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  };

  var spinner = "<paper-spinner id='loadingIndicator' active='' class='style-scope sj-search-box x-scope paper-spinner-0'>\
    <div id='spinnerContainer' class='active  style-scope paper-spinner'>\
      <div class='spinner-layer layer-1 style-scope paper-spinner'>\
        <div class='circle-clipper left style-scope paper-spinner'>\
          <div class='circle style-scope paper-spinner'></div>\
        </div><div class='gap-patch style-scope paper-spinner'>\
          <div class='circle style-scope paper-spinner'></div>\
        </div><div class='circle-clipper right style-scope paper-spinner'>\
          <div class='circle style-scope paper-spinner'></div>\
        </div>\
      </div>\
    </div>\
  </paper-spinner>";

  loadAjax = function (url) {
    $("#content").html('<div class="text-center">' + spinner + '</div>');
    $.get(url, function (response) {
      var html = $(response);
      $("#content").replaceWith($("#content", html));
      $(window).resize();
      window.history.pushState({}, "", url);

      if ($('body').hasClass('post-type-archive-3d-flip-book')) {
        $('script[src$="link-lightbox.min.js"]').remove();
        $('<script>').attr('src', '/wp-content/plugins/unreal-flip-book/assets/js/link-lightbox.min.js').appendTo('head');
      }
    });
  };
})(jQuery); // Fully reference jQuery after this point.